export default __webpack_public_path__ + "static/media/timerTick.d23f5c69.mp3";